<template>
	<div class="wrap">
		<div class="login-box">
			<img class="logo" src="@/assets/images/logo-horizontal.png" />
			<div class="login-title">
				<div class="tt">云上乡村平台管理</div>
				<div class="tt-en">Cloud Village MANAGEMENT</div>
			</div>
			<div class="login-content">
				<el-form ref="vForm" class="form" :model="vForm">
					<el-form-item class="form-group" prop="loginName" :rules="validator.loginName">
						<el-input v-model="vForm.loginName" class="form-control" placeholder="账号" clearable></el-input>
					</el-form-item>
					<el-form-item class="form-group" prop="password" :rules="validator.password">
						<el-input v-model="vForm.password" class="form-control" placeholder="密码" show-password></el-input>
					</el-form-item>
					<div class="login-btn-box">
						<el-button ref="submitBtn" class="login-btn" :loading="loginLoading" type="primary" @click="login">
							登录
						</el-button>
					</div>
				</el-form>
			</div>
		</div>
		<div id="verificationBox"></div>
	</div>
</template>

<script>
	import validator from "./validator";
	import cookie from "@/api/cookie";

	export default {
		data() {
			return {
				loginLoading: false,
				validator: validator, //表单验证
				vForm: {
					//账号密码登录
					loginName: "",
					password: ""
				}
			};
		},

		created() {
			document.addEventListener("keydown", this.bindDoLogin);
		},

		destroyed() {
			document.removeEventListener("keydown", this.bindDoLogin);
		},

		methods: {
			bindDoLogin(e) {
				if (e.keyCode == 13) {
					this.login();
				}
			},

			//账号密码登录
			async login() {
				this.loginLoading = true;
				try {
					await this.$refs.vForm.validate();
					let res = await this.api.admin.login(this.vForm);
					cookie.setToken(res.data.adminToken);
					this.$store.commit('user/SET_USERINFO',null);
					if (this.$route.query.forward) {
						location.href = decodeURIComponent(this.$route.query.forward);
					} else {
						this.$router.replace("/");
					}
				} catch (e) {
					console.error(e);
				}
				this.loginLoading = false;
			}
		}
	};
</script>

<style scoped lang="scss">
	.wrap {
		height: 100vh;
		background: url("../../assets/images/login-bg.png") no-repeat center;
		background-size: cover;
		position: relative;
	}

	.login-box {
		width: 878px;
		height: 450px;
		border-radius: 6px;
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		box-sizing: border-box;
		background: #fff url("../../assets/images/login-box-bg.png") left center no-repeat;
		background-size: auto 100%;
	}

	.logo {
		position: absolute;
		display: block;
		top: 40px;
		left: 40px;
		width: 180px;
	}

	.login-title {
		width: 354px;
		position: absolute;
		top: 40px;
		left: 480px;
		text-align: center;

		.tt {
			font-size: 24px;
			font-weight: bold;
		}

		.tt-en {
			font-size: 18px;
			color: #999;
		}
	}

	.login-content {
		position: absolute;
		top: 150px;
		left: 480px;
		width: 354px;
	}

	.login-btn-box {
		margin-top: 50px;
	}

	input::-webkit-input-placeholder {
		font-size: 14px;
		color: #cacaca;
	}

	.login-btn {
		display: block;
		width: 100%;
		font-size: 16px;
		letter-spacing: 6px;
		background: linear-gradient(
				180deg,
				rgba(62, 144, 255, 1) 0%,
				rgba(21, 113, 238, 1) 100%
		);
		border-radius: 35px;
		border: 0;
		height: 50px;

		&:hover,
		&:focus {
			background: linear-gradient(
					180deg,
					rgba(62, 144, 255, 1) 0%,
					rgba(21, 113, 238, 1) 100%
			);
		}
	}

	.login-mode {
		position: absolute;
		right: 12px;
		top: 12px;
		cursor: pointer;
	}

	.login-mode .icon {
		display: block;
		width: 34px;
		height: 34px;
	}

	.login-mode .icon-computer {
		font-size: 30px;
		color: #d6d6d6;
	}

	#verificationBox ::v-deep .yp-riddler-winbox {
		margin-top: -125px;
		top: 50%;
		position: relative;
	}

	.login-box ::v-deep .form-control .el-input__inner {
		border-width: 0;
		border-radius: 20px;
		padding-left: 30px;
		height: 50px;
		background: #f6f6f6;
	}

	.qrcode-box {
		position: relative;
		border: 1px solid #eee;
		width: 280px;
		height: 280px;
		margin: 0 auto;
	}

	.qrcode-img {
		display: block;
		width: 100%;
		height: 100%;
	}

	.qrcode-box .mask {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.8);
		color: #fff;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.qrcode-box .mask .txt {
		cursor: pointer;
	}

	.qrcode-box .mask .iconfont {
		cursor: pointer;
	}
</style>
